import script from "./UserTokens.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserTokens.vue?vue&type=script&setup=true&lang=ts"

import "./UserTokens.vue?vue&type=style&index=0&id=1767f0b0&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1767f0b0"]])

export default __exports__